// extracted by mini-css-extract-plugin
export var active = "_f0-2";
export var recordingDot = "_f0-1";
export var recordingIndicator = "_f0-0";